interface CADFileButtonProps {
  fileName: string
}

export const CADFileButton = ({ fileName }: CADFileButtonProps) => {
  return <span className="bg-blue-50 py-1 px-2 rounded-md">{fileName}</span>
}
